(function ($, window) {

    if (!$('body').hasClass('page-template-default')) {
        return;
    }

    let sectionStyles = ['plain', 'grey'];

    let sectionHeadings = $('#main-content').find('.container-inner-narrow > h1, .container-inner-narrow > h2').parent();

    sectionHeadings.each((i, el) => {
        let headingEl = $(el);
        let sectionClass =  sectionStyles[i % sectionStyles.length];

        // Check for heading class overriding section style
        let headingElClasses = headingEl.find('> h1, > h2').attr('class');
        if (headingElClasses && headingElClasses.split(' ').some(cl => sectionStyles.includes(cl))) {
            sectionClass = headingElClasses.split(' ').filter(cl => sectionStyles.includes(cl))[0];
        }
        
        headingEl.add(headingEl.nextUntil(sectionHeadings.eq(i+1)))
            .wrapAll($('<section/>').addClass(sectionClass));
    });

})(jQuery, window);